import React from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import useNotification from "../hooks/useNotification";

import { setLoginPageComponent } from "../redux/actions/setLoginPageComponent";

import { redbutton } from "../style/variables";

import {
  Login,
  SignUp,
  ResetPassword,
  EmailSent,
  LoginCheckEmail,
  Button,
} from "../components";

const types = ["signup", "login", "resetpass", "emailsent", "loginCheckEmail"];

export const StyledLoginPage = styled.div`
  .login {
    display: flex;
    width: 100%;
    max-width: 1214px;
    height: calc(100vh - 115px);
    max-height: 718px;
    margin: 30px auto 0;
    background-color: #fff;
    border-radius: 20px;
    box-shadow: -10px 9px 21px rgba(35, 35, 35, 0.07);
  }
  .login__actions {
    width: 55%;
    min-height: 618px;
    &.type--resetpass {
      padding-top: 85px;
      background: url("data:image/svg+xml;utf8, #{$typeresetpassurl}") no-repeat
        50% 7%;
      .button {
        width: 182px;
      }
      .login__forms {
        width: 401px;
        label {
          margin-left: 10px;
        }
        .input-wrapper {
          max-width: 345px;
        }
      }
    }
  }
  .login__forms {
    padding: 121px 15px 0 15px;
    max-width: 368px;
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    h2 {
      font-weight: 500;
      font-size: 25px;
      line-height: 31px;
      text-align: center;
      color: #232323;
      margin-bottom: 7px;
    }
    h3 {
      margin: 0 0 30px;
      font-weight: 300;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      color: #505356;
    }
    .signUpLink {
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      text-decoration: none;
      color: #5541d7;
    }
    label {
      padding-bottom: 0;
      margin-bottom: 6px;
      font-weight: 300;
      font-size: 14px;
      line-height: 18px;
      color: #232323;
      text-align: left;
    }

    .input-wrapper {
      display: flex;
      align-items: center;
      margin: 0 auto 15px;
      width: 100%;
      max-width: 368px;
      border-radius: 8px;
      border: 1px solid #dddddd;
      &.focus-within {
        border: 1px solid rgba(85, 65, 215, 0.5);
      }
      transition: 0.3s;
      svg {
        cursor: pointer;
        padding-right: 10px;
        &.redEye {
          path {
            fill: ${redbutton};
          }
        }
        &:hover {
          path {
            fill: #5541d7;
          }
        }
      }
      .user-password-input {
        width: 83.2%;
        //max-width: 276px;
      }
      input {
        padding: 0 15px;
        height: 40px;
        width: 100%;
        max-width: 318px;
        border-radius: 8px;
        border: none;
      }

      &.loginBadRed {
        border: 1px solid #ff6562;
      }
    }
    .button.purple {
      margin: 25px auto 0;
      min-width: 200px;
    }
  }
`;

function LoginPage() {
  const dispatch = useDispatch();
  const loginPageComponent = useSelector(
    ({ loginPageComponent }) => loginPageComponent.type
  );

  const showNotification = useNotification();

  const handleLogin = () => {
    dispatch(setLoginPageComponent(types[1]));
  };
  const handleSignup = () => {
    dispatch(setLoginPageComponent(types[0]));
  };
  const handleResetPass = () => {
    dispatch(setLoginPageComponent(types[2]));
  };
  const handleEmailSent = (email) => {
    if (email === "") {
      showNotification(
        "error",
        "Field is blank",
        "Write your email in field",
        5000
      );
    } else {
      dispatch(setLoginPageComponent(types[3], email));
    }
  };

  return (
    <StyledLoginPage>
      <div className="login">
        {loginPageComponent === types[0] && (
          <SignUp handleLogin={handleLogin} />
        )}
        {loginPageComponent === types[1] && (
          <Login
            handleResetPass={handleResetPass}
            handleSignup={handleSignup}
          />
        )}
        {loginPageComponent === types[2] && (
          <ResetPassword handleEmailSent={handleEmailSent} />
        )}
        {loginPageComponent === types[3] && (
          <EmailSent handleLogin={handleLogin} />
        )}
        {loginPageComponent === types[4] && <LoginCheckEmail />}
        <div className="login__static">
          <div className="static__behind-block static__inner-block">
            <svg
              className="behind__purple-arrow"
              width="106"
              height="86"
              viewBox="0 0 106 86"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M44 62C77.1373 62 104 35.1373 104 2H44V62Z"
                stroke="#5541D7"
                strokeWidth="3.31108"
              />
              <path
                d="M0 69.9956C0 67.7889 1.81032 66 4.0435 66L76.9565 66.0232C79.1897 66.0232 81 67.8121 81 70.0188V82.0057C81 84.2125 79.1897 86 76.9565 86L4.0435 85.9782C1.81032 85.9782 0 84.1893 0 81.9825V69.9956Z"
                fill="#5541D7"
              />
              <path
                d="M66.3218 26.7214C67.6957 26.1992 69.4382 27.8135 69.0357 29.2345L64.3037 45.9112C63.8712 47.4373 61.5113 47.0145 60.8829 45.2995L58.7169 39.3892C58.4612 38.6903 57.8334 38.1103 57.1203 37.9113L51.0873 36.228C49.3355 35.7393 48.7232 33.4078 50.1983 32.8479L66.3218 26.7214Z"
                fill="#5541D7"
              />
              <path
                d="M12.4145 72.456H15.5585C16.9585 72.456 18.0425 72.828 18.8105 73.572C19.5865 74.316 19.9745 75.364 19.9745 76.716C19.9745 78.076 19.5865 79.132 18.8105 79.884C18.0425 80.628 16.9585 81 15.5585 81H12.4145V72.456ZM15.4625 79.74C17.4305 79.74 18.4145 78.732 18.4145 76.716C18.4145 74.716 17.4305 73.716 15.4625 73.716H13.9625V79.74H15.4625ZM26.8111 78.048H22.6351C22.6671 78.696 22.8271 79.176 23.1151 79.488C23.4111 79.792 23.8471 79.944 24.4231 79.944C25.0871 79.944 25.7031 79.728 26.2711 79.296L26.7031 80.328C26.4151 80.56 26.0591 80.748 25.6351 80.892C25.2191 81.028 24.7951 81.096 24.3631 81.096C23.3711 81.096 22.5911 80.816 22.0231 80.256C21.4551 79.696 21.1711 78.928 21.1711 77.952C21.1711 77.336 21.2951 76.788 21.5431 76.308C21.7911 75.828 22.1391 75.456 22.5871 75.192C23.0351 74.92 23.5431 74.784 24.1111 74.784C24.9431 74.784 25.5991 75.056 26.0791 75.6C26.5671 76.136 26.8111 76.876 26.8111 77.82V78.048ZM24.1471 75.864C23.7471 75.864 23.4191 75.984 23.1631 76.224C22.9151 76.456 22.7551 76.796 22.6831 77.244H25.5031C25.4551 76.788 25.3151 76.444 25.0831 76.212C24.8591 75.98 24.5471 75.864 24.1471 75.864ZM33.7718 74.952L31.1198 81H29.8118L27.1958 74.952H28.7678L30.5078 79.296L32.2838 74.952H33.7718ZM39.81 78.048H35.634C35.666 78.696 35.826 79.176 36.114 79.488C36.41 79.792 36.846 79.944 37.422 79.944C38.086 79.944 38.702 79.728 39.27 79.296L39.702 80.328C39.414 80.56 39.058 80.748 38.634 80.892C38.218 81.028 37.794 81.096 37.362 81.096C36.37 81.096 35.59 80.816 35.022 80.256C34.454 79.696 34.17 78.928 34.17 77.952C34.17 77.336 34.294 76.788 34.542 76.308C34.79 75.828 35.138 75.456 35.586 75.192C36.034 74.92 36.542 74.784 37.11 74.784C37.942 74.784 38.598 75.056 39.078 75.6C39.566 76.136 39.81 76.876 39.81 77.82V78.048ZM37.146 75.864C36.746 75.864 36.418 75.984 36.162 76.224C35.914 76.456 35.754 76.796 35.682 77.244H38.502C38.454 76.788 38.314 76.444 38.082 76.212C37.858 75.98 37.546 75.864 37.146 75.864ZM41.1402 72.168H42.6282V81H41.1402V72.168ZM47.0771 81.096C46.4611 81.096 45.9171 80.968 45.4451 80.712C44.9811 80.456 44.6211 80.092 44.3651 79.62C44.1171 79.14 43.9931 78.58 43.9931 77.94C43.9931 77.3 44.1171 76.744 44.3651 76.272C44.6211 75.792 44.9811 75.424 45.4451 75.168C45.9171 74.912 46.4611 74.784 47.0771 74.784C47.6851 74.784 48.2211 74.912 48.6851 75.168C49.1491 75.424 49.5051 75.792 49.7531 76.272C50.0091 76.744 50.1371 77.3 50.1371 77.94C50.1371 78.58 50.0091 79.14 49.7531 79.62C49.5051 80.092 49.1491 80.456 48.6851 80.712C48.2211 80.968 47.6851 81.096 47.0771 81.096ZM47.0651 79.92C47.5771 79.92 47.9651 79.756 48.2291 79.428C48.5011 79.092 48.6371 78.596 48.6371 77.94C48.6371 77.292 48.5011 76.8 48.2291 76.464C47.9571 76.12 47.5731 75.948 47.0771 75.948C46.5731 75.948 46.1851 76.12 45.9131 76.464C45.6411 76.8 45.5051 77.292 45.5051 77.94C45.5051 78.596 45.6371 79.092 45.9011 79.428C46.1731 79.756 46.5611 79.92 47.0651 79.92ZM54.9467 74.784C55.4667 74.784 55.9267 74.92 56.3267 75.192C56.7347 75.456 57.0507 75.832 57.2747 76.32C57.5067 76.8 57.6227 77.352 57.6227 77.976C57.6227 78.6 57.5107 79.148 57.2867 79.62C57.0627 80.092 56.7467 80.456 56.3387 80.712C55.9387 80.968 55.4747 81.096 54.9467 81.096C54.5067 81.096 54.1147 81.004 53.7707 80.82C53.4267 80.628 53.1627 80.364 52.9787 80.028V83.592H51.4907V76.656C51.4907 76.016 51.4587 75.444 51.3947 74.94H52.7987L52.9187 75.984C53.0787 75.608 53.3387 75.316 53.6987 75.108C54.0587 74.892 54.4747 74.784 54.9467 74.784ZM54.5387 79.92C55.0427 79.92 55.4307 79.752 55.7027 79.416C55.9747 79.08 56.1107 78.6 56.1107 77.976C56.1107 77.344 55.9747 76.852 55.7027 76.5C55.4307 76.14 55.0467 75.96 54.5507 75.96C54.0387 75.96 53.6467 76.132 53.3747 76.476C53.1027 76.82 52.9667 77.312 52.9667 77.952C52.9667 78.584 53.1027 79.072 53.3747 79.416C53.6467 79.752 54.0347 79.92 54.5387 79.92ZM64.2961 78.048H60.1201C60.1521 78.696 60.3121 79.176 60.6001 79.488C60.8961 79.792 61.3321 79.944 61.9081 79.944C62.5721 79.944 63.1881 79.728 63.7561 79.296L64.1881 80.328C63.9001 80.56 63.5441 80.748 63.1201 80.892C62.7041 81.028 62.2801 81.096 61.8481 81.096C60.8561 81.096 60.0761 80.816 59.5081 80.256C58.9401 79.696 58.6561 78.928 58.6561 77.952C58.6561 77.336 58.7801 76.788 59.0281 76.308C59.2761 75.828 59.6241 75.456 60.0721 75.192C60.5201 74.92 61.0281 74.784 61.5961 74.784C62.4281 74.784 63.0841 75.056 63.5641 75.6C64.0521 76.136 64.2961 76.876 64.2961 77.82V78.048ZM61.6321 75.864C61.2321 75.864 60.9041 75.984 60.6481 76.224C60.4001 76.456 60.2401 76.796 60.1681 77.244H62.9881C62.9401 76.788 62.8001 76.444 62.5681 76.212C62.3441 75.98 62.0321 75.864 61.6321 75.864ZM68.8903 74.796C69.1223 74.796 69.3223 74.828 69.4903 74.892L69.4783 76.26C69.2223 76.156 68.9583 76.104 68.6863 76.104C68.1743 76.104 67.7823 76.252 67.5103 76.548C67.2463 76.844 67.1143 77.236 67.1143 77.724V81H65.6263V76.656C65.6263 76.016 65.5943 75.444 65.5303 74.94H66.9343L67.0543 76.008C67.2063 75.616 67.4463 75.316 67.7743 75.108C68.1023 74.9 68.4743 74.796 68.8903 74.796Z"
                fill="white"
              />
            </svg>
            <div className="behind__list">
              <div className="list__item list__item-first">
                <svg
                  className="behind__purplelock"
                  width="12"
                  height="16"
                  viewBox="0 0 12 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.32553 5.33257H3.67447V3.80914C3.67447 2.50629 4.71742 1.44686 6 1.44686C7.28258 1.44686 8.32553 2.50629 8.32553 3.80914V5.33257ZM6 12.1897C5.17532 12.1897 4.50029 11.504 4.50029 10.6663C4.50029 9.82857 5.17532 9.14286 6 9.14286C6.82468 9.14286 7.49971 9.82857 7.49971 10.6663C7.49971 11.504 6.82468 12.1897 6 12.1897ZM10.5003 5.33257H9.74986V3.80914C9.74986 1.70629 8.07013 0 6 0C3.92987 0 2.25014 1.70629 2.25014 3.80914V5.33257H1.49971C0.675033 5.33257 0 6.01943 0 6.85714V14.4754C0 15.3131 0.675033 16 1.49971 16H10.5003C11.325 16 12 15.3131 12 14.4754V6.85714C12 6.01943 11.325 5.33257 10.5003 5.33257Z"
                    fill="#5541D7"
                  />
                </svg>
                <span>Password</span>
                <svg
                  className="behind__greendot"
                  width="9"
                  height="9"
                  viewBox="0 0 9 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 4.5C9 6.98512 6.98512 9 4.5 9C2.01488 9 0 6.98512 0 4.5C0 2.01488 2.01488 0 4.5 0C6.98512 0 9 2.01488 9 4.5Z"
                    fill="#5BC044"
                  />
                </svg>
              </div>
              <div className="list__item">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.8462 9.23077H11.5385V5.76923H13.8462C14.4831 5.76923 15 5.25231 15 4.61538C15 3.97846 14.4831 3.46154 13.8462 3.46154H11.5385V1.15385C11.5385 0.516925 11.0215 0 10.3846 0C9.74769 0 9.23077 0.516925 9.23077 1.15385V3.46154H5.76923V1.15385C5.76923 0.516925 5.25231 0 4.61538 0C3.97846 0 3.46154 0.516925 3.46154 1.15385V3.46154H1.15385C0.516921 3.46154 0 3.97846 0 4.61538C0 5.25231 0.516921 5.76923 1.15385 5.76923H3.46154V9.23077H1.15385C0.516921 9.23077 0 9.74769 0 10.3846C0 11.0215 0.516921 11.5385 1.15385 11.5385H3.46154V13.8462C3.46154 14.4831 3.97846 15 4.61538 15C5.25231 15 5.76923 14.4831 5.76923 13.8462V11.5385H9.23077V13.8462C9.23077 14.4831 9.74769 15 10.3846 15C11.0215 15 11.5385 14.4831 11.5385 13.8462V11.5385H13.8462C14.4831 11.5385 15 11.0215 15 10.3846C15 9.74769 14.4831 9.23077 13.8462 9.23077ZM5.76923 9.23077V5.76923H9.23077V9.23077H5.76923Z"
                    fill="#8B8F9A"
                  />
                </svg>
                <span>Password</span>{" "}
              </div>
              <div className="list__item">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.8462 9.23077H11.5385V5.76923H13.8462C14.4831 5.76923 15 5.25231 15 4.61538C15 3.97846 14.4831 3.46154 13.8462 3.46154H11.5385V1.15385C11.5385 0.516925 11.0215 0 10.3846 0C9.74769 0 9.23077 0.516925 9.23077 1.15385V3.46154H5.76923V1.15385C5.76923 0.516925 5.25231 0 4.61538 0C3.97846 0 3.46154 0.516925 3.46154 1.15385V3.46154H1.15385C0.516921 3.46154 0 3.97846 0 4.61538C0 5.25231 0.516921 5.76923 1.15385 5.76923H3.46154V9.23077H1.15385C0.516921 9.23077 0 9.74769 0 10.3846C0 11.0215 0.516921 11.5385 1.15385 11.5385H3.46154V13.8462C3.46154 14.4831 3.97846 15 4.61538 15C5.25231 15 5.76923 14.4831 5.76923 13.8462V11.5385H9.23077V13.8462C9.23077 14.4831 9.74769 15 10.3846 15C11.0215 15 11.5385 14.4831 11.5385 13.8462V11.5385H13.8462C14.4831 11.5385 15 11.0215 15 10.3846C15 9.74769 14.4831 9.23077 13.8462 9.23077ZM5.76923 9.23077V5.76923H9.23077V9.23077H5.76923Z"
                    fill="#8B8F9A"
                  />
                </svg>
                <span>Password</span>{" "}
              </div>
              <div className="list__item">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.8462 9.23077H11.5385V5.76923H13.8462C14.4831 5.76923 15 5.25231 15 4.61538C15 3.97846 14.4831 3.46154 13.8462 3.46154H11.5385V1.15385C11.5385 0.516925 11.0215 0 10.3846 0C9.74769 0 9.23077 0.516925 9.23077 1.15385V3.46154H5.76923V1.15385C5.76923 0.516925 5.25231 0 4.61538 0C3.97846 0 3.46154 0.516925 3.46154 1.15385V3.46154H1.15385C0.516921 3.46154 0 3.97846 0 4.61538C0 5.25231 0.516921 5.76923 1.15385 5.76923H3.46154V9.23077H1.15385C0.516921 9.23077 0 9.74769 0 10.3846C0 11.0215 0.516921 11.5385 1.15385 11.5385H3.46154V13.8462C3.46154 14.4831 3.97846 15 4.61538 15C5.25231 15 5.76923 14.4831 5.76923 13.8462V11.5385H9.23077V13.8462C9.23077 14.4831 9.74769 15 10.3846 15C11.0215 15 11.5385 14.4831 11.5385 13.8462V11.5385H13.8462C14.4831 11.5385 15 11.0215 15 10.3846C15 9.74769 14.4831 9.23077 13.8462 9.23077ZM5.76923 9.23077V5.76923H9.23077V9.23077H5.76923Z"
                    fill="#8B8F9A"
                  />
                </svg>{" "}
                <span>Password</span>
              </div>
              <div className="list__item">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.8462 9.23077H11.5385V5.76923H13.8462C14.4831 5.76923 15 5.25231 15 4.61538C15 3.97846 14.4831 3.46154 13.8462 3.46154H11.5385V1.15385C11.5385 0.516925 11.0215 0 10.3846 0C9.74769 0 9.23077 0.516925 9.23077 1.15385V3.46154H5.76923V1.15385C5.76923 0.516925 5.25231 0 4.61538 0C3.97846 0 3.46154 0.516925 3.46154 1.15385V3.46154H1.15385C0.516921 3.46154 0 3.97846 0 4.61538C0 5.25231 0.516921 5.76923 1.15385 5.76923H3.46154V9.23077H1.15385C0.516921 9.23077 0 9.74769 0 10.3846C0 11.0215 0.516921 11.5385 1.15385 11.5385H3.46154V13.8462C3.46154 14.4831 3.97846 15 4.61538 15C5.25231 15 5.76923 14.4831 5.76923 13.8462V11.5385H9.23077V13.8462C9.23077 14.4831 9.74769 15 10.3846 15C11.0215 15 11.5385 14.4831 11.5385 13.8462V11.5385H13.8462C14.4831 11.5385 15 11.0215 15 10.3846C15 9.74769 14.4831 9.23077 13.8462 9.23077ZM5.76923 9.23077V5.76923H9.23077V9.23077H5.76923Z"
                    fill="#8B8F9A"
                  />
                </svg>{" "}
                <span>Password</span>
              </div>
            </div>
          </div>
          <div className="static__front-block static__inner-block">
            <svg
              className="front__orange-arrow"
              width="88"
              height="60"
              viewBox="0 0 88 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 43.7271C0 41.5179 1.79089 39.7271 4.00013 39.7271H83.9999C86.2091 39.7271 88 41.5179 88 43.7271V55.7271C88 57.9362 86.2091 59.7271 83.9999 59.7271H4.00013C1.79089 59.7271 0 57.9362 0 55.7271V43.7271Z"
                fill="#FF6562"
              />
              <path
                d="M16.1315 9.52693C15.3402 7.90476 16.9451 6.15359 18.63 6.79929L38.4051 14.3875C40.2145 15.0813 40.0617 17.6901 38.1848 18.1693L31.7165 19.8212C30.9516 20.016 30.3752 20.6471 30.2474 21.4259L29.1662 28.0144C28.8525 29.9274 26.2668 30.3055 25.4179 28.564L16.1315 9.52693Z"
                fill="#FF6562"
              />
              <path
                d="M32.2379 54.8351C31.3979 54.8351 30.6619 54.6551 30.0299 54.2951C29.4059 53.9351 28.9259 53.4271 28.5899 52.7711C28.2539 52.1071 28.0859 51.3311 28.0859 50.4431C28.0859 49.5631 28.2539 48.7951 28.5899 48.1391C28.9259 47.4751 29.4059 46.9671 30.0299 46.6151C30.6619 46.2551 31.3979 46.0751 32.2379 46.0751C32.8139 46.0751 33.3539 46.1671 33.8579 46.3511C34.3699 46.5271 34.7939 46.7751 35.1299 47.0951L34.6259 48.2231C34.2419 47.9111 33.8579 47.6871 33.4739 47.5511C33.0979 47.4071 32.6939 47.3351 32.2619 47.3351C31.4379 47.3351 30.7979 47.6031 30.3419 48.1391C29.8939 48.6751 29.6699 49.4431 29.6699 50.4431C29.6699 51.4511 29.8939 52.2271 30.3419 52.7711C30.7899 53.3071 31.4299 53.5751 32.2619 53.5751C32.6939 53.5751 33.0979 53.5071 33.4739 53.3711C33.8579 53.2271 34.2419 52.9991 34.6259 52.6871L35.1299 53.8151C34.7939 54.1351 34.3699 54.3871 33.8579 54.5711C33.3539 54.7471 32.8139 54.8351 32.2379 54.8351ZM36.5287 45.8951H38.0167V54.7271H36.5287V45.8951ZM39.7176 48.6671H41.2056V54.7271H39.7176V48.6671ZM41.2896 45.9191V47.3951H39.6216V45.9191H41.2896ZM48.2105 51.7751H44.0345C44.0665 52.4231 44.2265 52.9031 44.5145 53.2151C44.8105 53.5191 45.2465 53.6711 45.8225 53.6711C46.4865 53.6711 47.1025 53.4551 47.6705 53.0231L48.1025 54.0551C47.8145 54.2871 47.4585 54.4751 47.0345 54.6191C46.6185 54.7551 46.1945 54.8231 45.7625 54.8231C44.7705 54.8231 43.9905 54.5431 43.4225 53.9831C42.8545 53.4231 42.5705 52.6551 42.5705 51.6791C42.5705 51.0631 42.6945 50.5151 42.9425 50.0351C43.1905 49.5551 43.5385 49.1831 43.9865 48.9191C44.4345 48.6471 44.9425 48.5111 45.5105 48.5111C46.3425 48.5111 46.9985 48.7831 47.4785 49.3271C47.9665 49.8631 48.2105 50.6031 48.2105 51.5471V51.7751ZM45.5465 49.5911C45.1465 49.5911 44.8185 49.7111 44.5625 49.9511C44.3145 50.1831 44.1545 50.5231 44.0825 50.9711H46.9025C46.8545 50.5151 46.7145 50.1711 46.4825 49.9391C46.2585 49.7071 45.9465 49.5911 45.5465 49.5911ZM53.0088 48.5111C54.4568 48.5111 55.1808 49.3431 55.1808 51.0071V54.7271H53.6808V51.0791C53.6808 50.5991 53.5888 50.2511 53.4048 50.0351C53.2208 49.8111 52.9368 49.6991 52.5528 49.6991C52.0968 49.6991 51.7288 49.8471 51.4488 50.1431C51.1688 50.4311 51.0288 50.8151 51.0288 51.2951V54.7271H49.5408V50.3831C49.5408 49.7431 49.5088 49.1711 49.4448 48.6671H50.8488L50.9568 49.6631C51.1648 49.2951 51.4448 49.0111 51.7968 48.8111C52.1568 48.6111 52.5608 48.5111 53.0088 48.5111ZM58.7392 49.7951V52.5071C58.7392 53.2191 59.0712 53.5751 59.7352 53.5751C59.9192 53.5751 60.1192 53.5431 60.3352 53.4791V54.6671C60.0712 54.7631 59.7512 54.8111 59.3752 54.8111C58.6872 54.8111 58.1592 54.6191 57.7912 54.2351C57.4232 53.8511 57.2392 53.2991 57.2392 52.5791V49.7951H56.0752V48.6671H57.2392V47.1911L58.7392 46.6871V48.6671H60.3472V49.7951H58.7392Z"
                fill="white"
              />
            </svg>
            <div className="front__header">
              <div className="header__motto">
                Communication <br /> made simple
              </div>
            </div>
            <div className="front__footer"></div>
          </div>
        </div>
      </div>

      {loginPageComponent === types[0] && (
        <div className="login-footer">
          Already have an account?{" "}
          <Button onClick={handleLogin} text={"Log in"} color={"white"} />
        </div>
      )}
    </StyledLoginPage>
  );
}

export default LoginPage;
